import { mapState } from "vuex";
import axios from "axios";

export default {
    name: "mixinFabricante",
    data: () => ({
        fabricantes: {},
    }),
    computed: {
        ...mapState(["backendUrl", "pgLimit", "usuario"]),
    },
    methods: {
        listarFabricantes() {
            return axios
                .post(`${this.backendUrl}produto/fabricante/listar`, {
                    limit: 9999,
                    offset: 0,
                    busca: null,
                })
                .then((res) => {
                    this.fabricantes = res.data;
                    this.fabricantes.lista = this.fabricantes.lista.filter((v) => {
                        return (
                            v.idfabricante !== 1
                        );
                    });
                });
        },
    },
    created() {
        this.listarFabricantes();
    },
}